import * as React from "react";
import { forwardRef } from "react";
const SvgRightChevron = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "-28 30 13.3 25", style: {
  enableBackground: "new -28 30 13.3 25"
}, xmlSpace: "preserve", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("polygon", { points: "-27.1,54.9 -28,54.1 -16.4,42.3 -28,30.9 -27.1,30 -14.7,42.3 " }));
const ForwardRef = forwardRef(SvgRightChevron);
export { ForwardRef as ReactComponent };
